module.exports = __webpack_public_path__ + "img/sx.1ca5cba8.svg";